"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var criterion_number_1 = require("./criterion-number");
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
/**
 * For standard category 'top' etc.
 */
var CategoryCriterionNumber = /** @class */ (function (_super) {
    __extends(CategoryCriterionNumber, _super);
    function CategoryCriterionNumber(filterItem, isNegating, value, _byMeasureId) {
        if (_byMeasureId === void 0) { _byMeasureId = null; }
        var _this = _super.call(this, filterItem, isNegating, value) || this;
        _this._byMeasureId = _byMeasureId;
        idm_common_util_frontend_1.PreconditionCheck.notUndefined(_byMeasureId);
        return _this;
    }
    Object.defineProperty(CategoryCriterionNumber.prototype, "byMeasureId", {
        get: function () {
            return this._byMeasureId;
        },
        set: function (byMeasureId) {
            this._byMeasureId = byMeasureId;
            this.validate();
        },
        enumerable: true,
        configurable: true
    });
    return CategoryCriterionNumber;
}(criterion_number_1.CriterionNumber));
exports.CategoryCriterionNumber = CategoryCriterionNumber;
//# sourceMappingURL=category-criterion-number.js.map